import { LOGIN_LOADING, LOGIN_SUCCESS, LOGIN_FAILURE } from "redux/types";

import { Dispatch } from "redux";

import { createNewItemService } from "services/createNewItemService";
import { notification } from "antd";
import { loginUrl } from "api/apiUrls";

export const loginAction =
  (data: any, callback?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: LOGIN_LOADING, payload: true });
      const response = await createNewItemService(
        `${loginUrl}`,
        data,
        "",
        "json"
      );

      // console.log(response);

      if (response?.data?.status === "success") {
        dispatch({ type: LOGIN_SUCCESS, payload: response.data });

        notification.success({
          message: `${response?.data?.user?.full_name}!, Welcome`,
        });
        callback();
      } else {
        notification.error({
          message: `${response?.data?.message}`,
        });
      }
    } catch (err) {
      dispatch({ type: LOGIN_FAILURE, payload: err });
    } finally {
      dispatch({ type: LOGIN_LOADING, payload: false });
    }
  };
